import React from 'react';
import s from './BonusesTable.module.css';
import print from '../../../../assets/img/icons/paperworkList/fluent_print-28-filled.svg';
import close from '../../../../assets/img/icons/paperworkList/gridicons_cross-circle.svg';
import {PaymentType} from '../../../../types/TypesUserOrders';

const TableRowElement = ({payment}: {payment: PaymentType}) => {
	const {client_name, create_date, contract, currency, money, order_id} = payment;
	
	// Определяем вид транзакции на основе order_id
	const transactionType = order_id ? 'Оформлено' : 'Виплачено';
	
	return (
		<div className={s.tableGridRow}>
			<div className={s.tableGridColumn}>{create_date.slice(0, 10)}</div>
			<div className={s.tableGridColumn}>{contract}</div>
			<div className={s.tableGridColumn}>{client_name}</div>
			<div className={s.tableGridColumn}>
				{money} {currency}
			</div>
			<div className={s.tableGridColumn}>{transactionType}</div>
			<div className={`${s.tableGridColumn} ${s.actions}`}>
				<img 
					src={print} 
					alt="print" 
					style={{opacity: 0.5, cursor: 'not-allowed'}}
				/>
				<img 
					src={close} 
					alt="close" 
					style={{opacity: 0.5, cursor: 'not-allowed'}}
				/>
			</div>
		</div>
	);
};

export default TableRowElement;
